module.exports = __webpack_public_path__ + "media/images/emblems/Truellikon-13f010121532c931625d21abc87edf59.svg";